import {
  PayerType,
  PayerDto,
  PaymentRequestDetailDto,
  PaymentRequestSearchResponseDto,
  PaymentRequestDto,
  PaymentRequestBalanceDto,
  FeesDTO,
  CreateOneTimePaymentDto,
  BankCardTypeDto,
  CreateBankCardDTO,
  CreateBankAccountDTO,
  TransactionDTO,
  PaymentRequestStatusType,
  CreatePaymentRequestResponseDto,
} from '@inosio/payments-sdk';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
export interface FeeParamsDto {
  PayerUUID: string;
  PaymentAmount: number;
  PropPayTypeId: number;
  PaymentRequestId?: string;
}
interface PaymentRequestDataPage {
  Rows: Array<PaymentRequestDto>;
}

export interface PrStatusTypeDto {
  statusDescription: string;
  requestUuid: string;
}

export interface CancelTransactionByPayerUuidDto {
  payerUuid: string;
  transactionUuid: string;
}
export interface addPaymentRequest {
  PayerUuid?: string;
  PayerName?: string;
  PayerEmail?: string;
  PropertyName?: string;
  PayeeUuid?: string;
  TotalAmount?: number;
  RequestDetails?: PaymentRequestDetailDto[];
  DueDate?: string;
  type?: PayerType;
}

export interface PaymentRequestInfo {
  /**
   * Bit flag that tells us whether the payer is generic (created on the fly) or an entity in our sys like an owner
   */
  IsPayerGeneric: boolean;
  PayerInfo: {
    Uuid?: string; //in case the payer is not generic and an entity in our sys
    FirstName: string;
    LastName: string;
    Email: string;
  };
  PayeeUuid: string;
  DepositBankAccountUuid: string;
  PropertyUuid?: string;
  RequestDetails?: PaymentRequestDetailDto[];
  DueDate?: string;
  TotalAmount?: number;
}

type PaymentRequests = {
  PayersList: PayerDto[];
  PaymentRequest: PaymentRequestSearchResponseDto;
  PaymentRequestDataPages: Array<PaymentRequestDataPage>;
  isFetchingApplicants: boolean;
  isCreatingApplicant: boolean;
  isApplicantCreationSuccess: boolean;
  isCreatingOwner: boolean;
  isOwnerCreationSuccess: boolean;
  isFetchedApplicants: boolean;
  isCreatingPaymentRequest: boolean;
  isPaymentRequestSuccess: boolean;
  CreatePRResponseDto: CreatePaymentRequestResponseDto;
  paymentRequestsError: any;
  applicantCreationResponse: PayerDto;
  ownerCreationResponse: PayerDto;
  addPaymentRequestDto: addPaymentRequest; //probably delete this schmuck
  PaymentRequestSetupObj: PaymentRequestInfo;
  closeAllModals: boolean;
  isFetchingPaymentRequest: boolean;
  isGetPaymentRequestSuccess: boolean;
  isResendingRequest: boolean;
  isResendingRequestSuccess: boolean;
  resendRequestError: any;
  PaymentRequestDetail: PaymentRequestDto | null;
  PaymentRequestBalanceDetail: PaymentRequestBalanceDto | null;
  isFetchingPaymentRequestDetail: boolean;
  isFetchingPaymentRequestFees: boolean;
  isPaymentRequestFeeSuccess: boolean;
  isPaymentRequestDetailSuccess: boolean;
  PaymentRequestFees: FeesDTO[];
  requestDetailsError: any;
  PrOtpDto: CreateOneTimePaymentDto;
  selectedPaymentOption: string;
  BankCardType: BankCardTypeDto | null;
  BankCardTypeError: any;
  BankCard: CreateBankCardDTO | null;
  BankAccount: CreateBankAccountDTO | null;
  isFetchingOtp: boolean;
  isSuccessOtp: boolean;
  errorPaymentRequestOtp: any;
  PrTransactionDto: TransactionDTO | null;
  PaymentRequestStatusDetails: PaymentRequestStatusType | null;
  isFetchingPaymentRequestStatusDetails: boolean;
  isSuccessPaymentRequestStatusDetails: boolean;
  errorPaymentRequestStatusDetails: any;
  PrStatusTypes: PrStatusTypeDto | null;
  isFetchingCancelTransaction: boolean;
  isSuccessCancelTransaction: boolean;
  errorCancelTransaction: any;
  CancelTransaction: CancelTransactionByPayerUuidDto | null;
};
const getInitialState = () => {
  return {
    PayersList: [],
    PaymentRequest: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
    PaymentRequestDataPages: [],
    PaymentRequestDetail: null,
    PaymentRequestBalanceDetail: null,
    closeAllModals: false,
    isFetchingApplicants: false,
    isCreatingApplicant: false,
    isApplicantCreationSuccess: false,
    isCreatingOwner: false,
    isOwnerCreationSuccess: false,
    isFetchedApplicants: false,
    paymentRequestsError: {},
    resendRequestError: {},
    requestDetailsError: {},
    isCreatingPaymentRequest: false,
    isPaymentRequestSuccess: false,
    CreatePRResponseDto: {} as CreatePaymentRequestResponseDto,
    isFetchingPaymentRequest: false,
    isGetPaymentRequestSuccess: false,
    isResendingRequest: false,
    isResendingRequestSuccess: false,
    isFetchingPaymentRequestDetail: false,
    isPaymentRequestDetailSuccess: false,
    isFetchingPaymentRequestFees: false,
    isPaymentRequestFeeSuccess: false,
    PaymentRequestFees: [],
    selectedPaymentOption: '',
    applicantCreationResponse: {
      Uuid: '',
      FirstName: '',
      LastName: '',
      type: PayerType.Applicant,
      Email: '',
    },
    ownerCreationResponse: {
      Uuid: '',
      FirstName: '',
      LastName: '',
      type: PayerType.Applicant,
      Email: '',
    },
    addPaymentRequestDto: {
      PayerUuid: '',
      PayeeUuid: '',
      TotalAmount: 0,
      DueDate: '',
      type: PayerType.Applicant,
      RequestDetails: [],
    },
    PaymentRequestSetupObj: {
      IsPayerGeneric: true,
      PayerInfo: {
        FirstName: '',
        LastName: '',
        Email: '',
      },
      PayeeUuid: '',
      DepositBankAccountUuid: '',
    },
    PrOtpDto: {
      PayerUuid: '',
      TotalAmount: 0,
      FeePayMethodUuid: '',
      FeeAmount: 0,
      Memo: 'Payment Request',
      TransactionDetails: [
        {
          Amount: 0,
          PropertyPaymentTypeId: 0,
          FromPayMethodUuid: '',
        },
      ],
    },
    BankCard: null,
    BankAccount: null,
    BankCardType: null,
    BankCardTypeError: {},
    isFetchingOtp: false,
    isSuccessOtp: false,
    errorPaymentRequestOtp: {},
    PrTransactionDto: null,
    PaymentRequestStatusDetails: null,
    isFetchingPaymentRequestStatusDetails: false,
    isSuccessPaymentRequestStatusDetails: false,
    errorPaymentRequestStatusDetails: {},
    PrStatusTypes: null,
    isFetchingCancelTransaction: false,
    isSuccessCancelTransaction: false,
    errorCancelTransaction: {},
    CancelTransaction: null,
  } as PaymentRequests;
};
const paymentRequestsSlice = createSlice({
  name: 'paymentRequests',
  initialState: getInitialState(),
  reducers: {
    getCreateApplicant(state) {
      state.paymentRequestsError = '';
      state.isCreatingApplicant = true;
    },
    setCreateApplicant(state, action) {
      state.isCreatingApplicant = false;
      state.isApplicantCreationSuccess = true;
      state.applicantCreationResponse = action.payload;
    },
    getCreateOwner(state) {
      state.paymentRequestsError = '';
      state.isOwnerCreationSuccess = false;
      state.isCreatingOwner = true;
    },
    setCreateOwner(state, action) {
      state.isCreatingOwner = false;
      state.isOwnerCreationSuccess = true;
      state.ownerCreationResponse = action.payload;
    },
    getApplicantsList(state, action) {
      state.paymentRequestsError = '';
      state.isFetchedApplicants = false;
      state.isFetchingApplicants = true;
    },
    setApplicantsList(state, action) {
      state.isFetchedApplicants = true;
      state.isFetchingApplicants = false;
      state.PayersList = action.payload;
    },
    setPaymentRequestError(state, action) {
      state.isFetchingApplicants = false;
      state.isCreatingApplicant = false;
      state.isCreatingOwner = false;
      state.isCreatingPaymentRequest = false;
      state.isOwnerCreationSuccess = false;
      state.paymentRequestsError = action.payload;
    },
    getCreatePaymentRequest(state, action) {
      state.isCreatingPaymentRequest = true;
      state.isPaymentRequestSuccess = false;
      state.paymentRequestsError = '';
    },
    setCreatePaymentRequest(state, action) {
      state.isCreatingPaymentRequest = false;
      state.isPaymentRequestSuccess = true;
      state.CreatePRResponseDto = action.payload;
    },
    getBuildPaymentRequestDto(state, action) {
      let temp = state.addPaymentRequestDto;
      state.addPaymentRequestDto = { ...temp, ...action.payload };
    },
    getBuildGenericPaymentRequestDto(state, action) {
      const existingInfo = state.PaymentRequestSetupObj;
      state.PaymentRequestSetupObj = { ...existingInfo, ...action.payload };
    },
    getCloseAllModals(state) {
      state.closeAllModals = true;
    },
    getActivateAllModels(state) {
      state.closeAllModals = false;
    },
    getResetErrorState(state) {
      state.paymentRequestsError = '';
    },
    getResetPrState(state) {
      //but not reset the payment requests
      const resetStates = {
        PayersList: [],
        closeAllModals: false,
        isFetchingApplicants: false,
        isCreatingApplicant: false,
        isApplicantCreationSuccess: false,
        isCreatingOwner: false,
        isOwnerCreationSuccess: false,
        isFetchedApplicants: false,
        paymentRequestsError: '',
        isCreatingPaymentRequest: false,
        isPaymentRequestSuccess: false,
        applicantCreationResponse: {
          Uuid: '',
          FirstName: '',
          LastName: '',
          type: PayerType.Applicant,
          Email: '',
        },
        ownerCreationResponse: {
          Uuid: '',
          FirstName: '',
          LastName: '',
          type: PayerType.Applicant,
          Email: '',
        },
        addPaymentRequestDto: {
          PayerUuid: '',
          PayeeUuid: '',
          TotalAmount: 0,
          DueDate: '',
          type: PayerType.Applicant,
          RequestDetails: [],
        },
        GenericPaymentRequestSetup: {
          IsPayerGeneric: true,
          PayerInfo: {
            FirstName: '',
            LastName: '',
            Email: '',
          },
          PayeeUuid: '',
          DepositBankAccountUuid: '',
        },
      };
      return { ...state, ...resetStates };
    },
    getPaymentRequestData(state) {
      state.paymentRequestsError = '';
      state.isGetPaymentRequestSuccess = false;
      state.isFetchingPaymentRequest = true;
    },
    setPaymentRequestData(state, action) {
      const _payload = action.payload;
      let currentPaymentRequestPages = [...state.PaymentRequestDataPages];
      if (_payload.RecordStart === 0) currentPaymentRequestPages = [];

      const whatPageResultsIsThis = Math.ceil(_payload.RecordStart / _payload.RangeSize);
      currentPaymentRequestPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows,
      };
      const paymentRequestData = {
        PaymentRequest: action.payload,
        PaymentRequestDataPages: currentPaymentRequestPages,
        isFetchingPaymentRequest: false,
        isGetPaymentRequestSuccess: true,
      };
      return { ...state, ...paymentRequestData };
    },
    getResendRequest(state) {
      state.resendRequestError = '';
      state.isResendingRequest = true;
      state.isResendingRequestSuccess = false;
    },
    setResendRequest(state) {
      state.isResendingRequest = false;
      state.isResendingRequestSuccess = true;
    },
    setResendRequestError(state, action) {
      state.isResendingRequest = false;
      state.isResendingRequestSuccess = false;
      state.resendRequestError = action.payload;
    },
    getPaymentRequestDetail(state) {
      state.requestDetailsError = {};
      state.isFetchingPaymentRequestDetail = true;
      state.isPaymentRequestDetailSuccess = false;
    },
    setPaymentRequestDetail(state, action) {
      state.isFetchingPaymentRequestDetail = false;
      state.isPaymentRequestDetailSuccess = true;
      state.PaymentRequestDetail = action.payload;
    },
    getPaymentRequestBalanceDetail(state) {
      state.requestDetailsError = {};
      state.isFetchingPaymentRequestDetail = true;
      state.isPaymentRequestDetailSuccess = false;
    },
    setPaymentRequestBalanceDetail(state, action) {
      state.isFetchingPaymentRequestDetail = false;
      state.isPaymentRequestDetailSuccess = true;
      state.PaymentRequestBalanceDetail = action.payload;
    },
    setPaymentRequestDetailError(state, action) {
      state.isFetchingPaymentRequestDetail = false;
      state.isPaymentRequestDetailSuccess = false;
      state.isPaymentRequestFeeSuccess = false;
      state.isFetchingPaymentRequestFees = false;
      state.requestDetailsError = action.payload;
    },
    getPaymentRequestFees(state) {
      state.requestDetailsError = {};
      state.isFetchingPaymentRequestFees = true;
      state.isPaymentRequestFeeSuccess = false;
    },
    setPaymentRequestFees(state, action) {
      state.isFetchingPaymentRequestFees = false;
      state.isPaymentRequestFeeSuccess = true;
      state.PaymentRequestFees = action.payload;
    },
    getBuildPaymentRequestOTPDto(state, action) {
      let temp = state.PrOtpDto;
      state.PrOtpDto = { ...temp, ...action.payload };
    },
    getSelectPayOption(state, action) {
      state.selectedPaymentOption = action.payload;
    },
    getBankCardTypeByPrefix(state) {},
    setBankCardTypeByPrefix(state, action) {
      state.BankCardType = action.payload;
    },
    setBankCardTypeError(state, action) {
      state.BankCardTypeError = action.payload;
    },
    getResetBankCardType(state) {
      state.BankCardType = null;
    },
    getBuildBankCard(state, action) {
      state.BankCard = action.payload;
    },
    getResetBuildBankCard(state) {
      state.BankCard = null;
    },
    getBuildBankAccount(state, action) {
      state.BankAccount = action.payload;
    },
    getResetBuildBankAccount(state) {
      state.BankAccount = null;
    },
    getfinalprotpdto(state) {
      state.PrOtpDto.BankAccount = state.BankAccount!;
      state.PrOtpDto.BankCard = state.BankCard!;
    },
    getMakePaymentRequestOtp(state) {
      state.isFetchingOtp = true;
      state.isSuccessOtp = false;
      state.errorPaymentRequestOtp = {};
    },
    setMakePaymentRequestOtp(state, action) {
      state.isFetchingOtp = false;
      state.isSuccessOtp = true;
      state.PrTransactionDto = action.payload;
    },
    setMakePaymentRequestOtpError(state, action) {
      state.isFetchingOtp = false;
      state.isSuccessOtp = false;
      state.errorPaymentRequestOtp = action.payload;
    },
    setMakePaymentRequestOtpErrorClear(state) {
      state.errorPaymentRequestOtp = {};
    },
    setCancelTransactionErrorClear(state) {
      state.errorCancelTransaction = {};
    },
    getPaymentRequestStatusType(state) {
      state.isFetchingPaymentRequestStatusDetails = true;
      state.isSuccessPaymentRequestStatusDetails = false;
      state.errorPaymentRequestStatusDetails = {};
    },
    setPaymentRequestStatusType(state, action) {
      state.isFetchingPaymentRequestStatusDetails = false;
      state.isSuccessPaymentRequestStatusDetails = true;
    },
    setPaymentRequestStatusError(state, action) {
      state.isFetchingPaymentRequestStatusDetails = false;
      state.isSuccessPaymentRequestStatusDetails = false;
      state.errorPaymentRequestStatusDetails = action.payload;
    },
    getResetPaymentRequestStatus(state) {
      state.PrStatusTypes = null;
      state.isFetchingPaymentRequestStatusDetails = false;
      state.isSuccessPaymentRequestStatusDetails = false;
      state.errorPaymentRequestStatusDetails = null;
      state.PaymentRequestDetail = null;
    },
    getCancelTransaction(state) {
      state.isFetchingCancelTransaction = true;
      state.isSuccessCancelTransaction = false;
      state.errorCancelTransaction = {};
    },
    setCancelTransaction(state) {
      state.isFetchingCancelTransaction = false;
      state.isSuccessCancelTransaction = true;
    },
    setCancelTransactionError(state, action) {
      state.isFetchingCancelTransaction = false;
      state.isSuccessCancelTransaction = false;
      state.errorCancelTransaction = action.payload;
    },
  },
});

export const {
  getCreateApplicant,
  setCreateApplicant,
  getApplicantsList, //may no longer need this
  setApplicantsList,
  setPaymentRequestError,
  getResetPrState,
  getCreateOwner,
  setCreateOwner,
  getCreatePaymentRequest,
  setCreatePaymentRequest,
  getBuildPaymentRequestDto,
  getBuildGenericPaymentRequestDto,
  getActivateAllModels,
  getCloseAllModals,
  getResetErrorState,
  getPaymentRequestData,
  setPaymentRequestData,
  getResendRequest,
  setResendRequest,
  setResendRequestError,
  getPaymentRequestDetail,
  setPaymentRequestDetail,
  setPaymentRequestDetailError,
  getPaymentRequestBalanceDetail,
  setPaymentRequestBalanceDetail,
  getPaymentRequestFees,
  setPaymentRequestFees,
  getBuildPaymentRequestOTPDto,
  getSelectPayOption,
  getBankCardTypeByPrefix,
  setBankCardTypeByPrefix,
  setBankCardTypeError,
  getBuildBankCard,
  getBuildBankAccount,
  getResetBuildBankCard,
  getResetBuildBankAccount,
  getResetBankCardType,
  getfinalprotpdto,
  getMakePaymentRequestOtp,
  setMakePaymentRequestOtp,
  setMakePaymentRequestOtpError,
  setMakePaymentRequestOtpErrorClear,
  getPaymentRequestStatusType,
  setPaymentRequestStatusType,
  setPaymentRequestStatusError,
  getResetPaymentRequestStatus,
  getCancelTransaction,
  setCancelTransaction,
  setCancelTransactionError,
  setCancelTransactionErrorClear,
} = paymentRequestsSlice.actions;

export default paymentRequestsSlice.reducer;

export const selectPaymentRequestsState = (state: RootState) => state.paymentRequestsState;
